module.exports = __webpack_public_path__ + "media/images/athletes/2384-17801dfdcb22aea9460a5c8bb916b85e.png";